type Args = {
  amount: number;
  duration: number;
};
type Threshold = {
  limit: number;
  duration: number;
};

export const verifyThreshold =
  (thresholds: Threshold[]) =>
  ({ amount, duration }: Args) => {
    if (!amount && !duration) return true;

    const range = thresholds.find((threshold) => amount <= threshold.limit);
    if (!range) {
      return false;
    }

    return duration >= range.duration;
  };
